/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetData } from './WidgetData';
import {
    WidgetDataFromJSON,
    WidgetDataFromJSONTyped,
    WidgetDataToJSON,
    WidgetDataToJSONTyped,
} from './WidgetData';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface WidgetResponse
 */
export interface WidgetResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WidgetResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof WidgetResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetResponse
     */
    displayName: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetResponse
     */
    category: string;
    /**
     * 
     * @type {WidgetData}
     * @memberof WidgetResponse
     */
    data: WidgetData;
}

/**
 * Check if a given object implements the WidgetResponse interface.
 */
export function instanceOfWidgetResponse(value: object): value is WidgetResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function WidgetResponseFromJSON(json: any): WidgetResponse {
    return WidgetResponseFromJSONTyped(json, false);
}

export function WidgetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'key': json['key'],
        'name': json['name'],
        'displayName': json['displayName'],
        'category': json['category'],
        'data': WidgetDataFromJSON(json['data']),
    };
}

export function WidgetResponseToJSON(json: any): WidgetResponse {
    return WidgetResponseToJSONTyped(json, false);
}

export function WidgetResponseToJSONTyped(value?: WidgetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'key': value['key'],
        'name': value['name'],
        'displayName': value['displayName'],
        'category': value['category'],
        'data': WidgetDataToJSON(value['data']),
    };
}

